/**
 * Asset Delete Confirmation component
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import type { GoldAsset } from '@/types/asset'

interface AssetDeleteConfirmProps {
  asset: GoldAsset
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isDeleting?: boolean
}

export function AssetDeleteConfirm({
  asset,
  isOpen,
  onClose,
  onConfirm,
  isDeleting = false,
}: AssetDeleteConfirmProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Xác nhận xóa tài sản</DialogTitle>
          <DialogDescription>
            Bạn có chắc chắn muốn xóa tài sản <strong>{asset.name}</strong>? Hành động này không thể
            hoàn tác.
          </DialogDescription>
        </DialogHeader>
        {asset.status === 'sold' && (
          <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded">
            <p className="text-sm">
              Tài sản này đã được đánh dấu là "đã bán". Nếu có giao dịch bán liên quan, bạn sẽ không
              thể xóa tài sản này.
            </p>
          </div>
        )}
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isDeleting}
          >
            Hủy
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Đang xóa...' : 'Xóa'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

